import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Chat Fill
 */

export default function ChatFillIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M8.63922 11.889C8.72489 11.7843 8.84983 11.7194 8.98434 11.7049C12.3843 11.3372 15 9.09275 15 6.37883C15 3.40818 11.866 1 8 1C4.13401 1 1 3.40818 1 6.37883C1 8.53231 2.64695 10.3902 5.02579 11.2494C5.23171 11.3238 5.375 11.5158 5.375 11.7348V14.4785C5.375 14.9484 5.96448 15.1588 6.26201 14.7951L8.63922 11.889Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
